import Vue from "@/plugins"
import { ActionTree, GetterTree, Module, MutationTree } from "vuex"
import { isEmpty } from "@/utils/validate"
import { notifyRequestError } from "@/utils/notify"
import { AxiosError, AxiosResponse } from "axios"
import {
    GET_GATEWAY_VERSION_LIST,
    GET_SBLDRIVE_VERSION_LIST,
    GET_JWT_TOKEN,
} from "@/store/types/getters"
import {
    UPDATE_GATEWAY_VERSION_LIST,
    UPDATE_SBLDRIVE_VERSION_LIST,
} from "@/store/types/mutations"
import {
    fetchGatewayVersionList,
    fetchSblDriveVersionList,
} from "@/store/types/actions"

export interface State {
    gatewayVersions: string[]
    sblDriveVersions: string[]
}

const state: State = {
    gatewayVersions: [],
    sblDriveVersions: [],
}

const namespaced = true

const getters: GetterTree<State, any> = {
    [GET_GATEWAY_VERSION_LIST](state: State): string[] {
        return state.gatewayVersions
    },
    [GET_SBLDRIVE_VERSION_LIST](state: State): string[] {
        return state.sblDriveVersions
    },
}

const mutations: MutationTree<State> = {
    [UPDATE_GATEWAY_VERSION_LIST](state: State, { payload }) {
        state.gatewayVersions = payload
    },
    [UPDATE_SBLDRIVE_VERSION_LIST](state: State, { payload }) {
        state.sblDriveVersions = payload
    },
}

const actions: ActionTree<State, any> = {
    [fetchGatewayVersionList]({ rootGetters, commit }) {
        if (isEmpty(rootGetters[GET_JWT_TOKEN])) {
            return
        }

        Vue.prototype
            .$api({
                method: "GET",
                url: "/api/v1/gateway-versions",
                headers: {
                    Authorization: "Bearer " + rootGetters[GET_JWT_TOKEN],
                },
            })
            .then((resp: AxiosResponse<string[]>) => {
                commit(UPDATE_GATEWAY_VERSION_LIST, { payload: resp.data })
            })
            .catch((err: AxiosError) => {
                notifyRequestError(err, "Faied to fetch gateway versions")
            })
    },
    [fetchSblDriveVersionList]({ rootGetters, commit }) {
        if (isEmpty(rootGetters[GET_JWT_TOKEN])) {
            return
        }

        Vue.prototype
            .$api({
                method: "GET",
                url: "/api/v1/sbldrive-versions",
                headers: {
                    Authorization: "Bearer " + rootGetters[GET_JWT_TOKEN],
                },
            })
            .then((resp: AxiosResponse<string[]>) => {
                commit(UPDATE_SBLDRIVE_VERSION_LIST, { payload: resp.data })
            })
            .catch((err: AxiosError) => {
                notifyRequestError(err, "Faied to fetch sbldrive versions")
            })
    },
}

const module: Module<State, any> = {
    namespaced,
    state,
    getters,
    mutations,
    actions,
}

export default module
